module.exports = __webpack_public_path__ + "static/media/car.da2e18d8.svg";